import { useTranslation } from "react-i18next";

import IconButton from "@mui/material/IconButton";

import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import { AppBar, Toolbar, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircleTwoTone";
import { green, grey, brown, cyan, blue } from "@mui/material/colors";
import ReceiptIcon from "@mui/icons-material/ReceiptTwoTone";
import Badge from "@mui/material/Badge";
import SyncIcon from "@mui/icons-material/SyncTwoTone";
import SettingsIcon from "@mui/icons-material/SettingsTwoTone";
import PersonIcon from "@mui/icons-material/PersonTwoTone";

import API from "../../utils/API";
import { AgentUtils } from "../../utils/AgentUtils";
import TerminalSelector from "../terminal/TerminalSelector";
import PProgressDialog from "../../components/pos/PProgressDialog";
import RegisterDevice from "../terminal/RegisterDevice";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";

import BuildIcon from "@mui/icons-material/BuildTwoTone";
import MSaleWindow from "./MSaleWindow";
import EventBusyIcon from "@mui/icons-material/EventBusyTwoTone";
import EventIcon from "@mui/icons-material/Event";
import DayCloseDataEntry from "./saleFlow/DayCloseDataEntry";
import DayCloseSummary from "./saleFlow/DayCloseSummary";
import DayOpenDialog from "./saleFlow/DayOpenDialog";
import MSetting from "./setting/MSetting";
import MSync from "./setting/MSync";
import { SaleUtils } from "../../utils/SaleUtils";
import PConfirm from "../../components/pos/PConfirm";
import PAlert from "../../components/pos/PAlert";
import PFileViewer from "../../components/pos/PFileViewer";
import AppsIcon from "@mui/icons-material/AppsTwoTone";
import db from "../../db/db";

export default function SaleHome(props) {
  const { t, i18n } = useTranslation();
  const [syncCount, setSyncCount] = useState("");

  const translate = t;

  const [currenctScreen, setCurrentScreen] = useState("");
  const [terminalBean, setTerminalBean] = useState(null);
  const [saleSession, setSaleSession] = useState(null);

  const [deviceId, setDeviceId] = useState(null);

  const [dayOpenClose, setDayOpenClose] = useState("day_open");
  const [enableSale, setEnableSale] = useState(false);

  const [showDayOpen, setShowDayOpen] = useState(false);
  const [showDayCloseDataEntry, setShowDayCloseDataEntry] = useState(false);
  const [showDayCloseSummary, setShowDayCloseSummary] = useState(false);
  const [shiftMode, setShiftMode] = useState(false);

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [localAlert, setLocalAlert] = useState({
    title: "",
    message: "",
    show: false,
  });

  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);

  var biRef = {};

  useEffect(() => {
    initScreen();
  }, []);

  function validateAndTriggerSale(saleType) {
    if (props.context.storeAdmin.enableShift) {
      let shiftSess = SaleUtils.getShiftSaleSession(saleSession);
      if (shiftSess.status == "closed") {
        setShiftMode(true);
        setShowDayOpen(true);
      }
      if (shiftSess.status == "closing") {
        //TODO Ensure it is open by Same User
        setShiftMode(true);
        setShowDayCloseSummary(true);
      }
      if (shiftSess.status == "active") {
        setCurrentScreen(saleType);
      }
    } else {
      setCurrentScreen(saleType);
    }
    //}
  }

  async function validate() {
    let syncMeta = await db.sync_meta.count();
    if (syncMeta > 0) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: "Can't proceed when something pending to sync with server",
      });
      return false;
    } else {
      return true;
    }
  }

  async function onNewSale() {
    if (await validate()) {
      validateAndTriggerSale("sale");
    }
  }

  async function onNewSaleReturn() {
    if (await validate()) {
      setCurrentScreen("saleReturn");
    }
  }

  async function onNewSaleOrder() {
    if (await validate()) {
      setCurrentScreen("saleOrder");
    }
  }

  async function onNewService() {
    if (await validate()) {
      setCurrentScreen("service");
    }
  }

  async function initScreen() {
    props.showProgress(translate("Checking Device..."));
    let devId = await AgentUtils.getDeviceId();
    if (localStorage.getItem("w_shopCode") === "PST") {
      devId = "1234";
    }
    props.hideProgress();
    if (devId == null) {
      if (localStorage.getItem("w_terminal")) {
        let term = JSON.parse(localStorage.getItem("w_terminal"));
        let termBean = await AgentUtils.getTerminalBeanFromId(term.id);
        if (termBean) {
          setTerminalBean(termBean);
          await checkSaleFlow(termBean);
        } else {
          setCurrentScreen("select_terminal");
        }
      } else {
        setCurrentScreen("select_terminal");
      }
    } else {
      setDeviceId(devId);
      let term = await AgentUtils.getTerminalBean(devId);
      if (term == null) {
        setCurrentScreen("propmpt_device_registration");
      } else {
        setTerminalBean(term);
        localStorage.setItem("w_terminal", JSON.stringify(term));
        await checkSaleFlow(term);
      }
    }
  }
  async function checkSaleFlow(tBean) {
    if (!tBean) {
      tBean = terminalBean;
    }
    if (props.context.store.tradingMode) {
      await checkTradingSaleFlow(tBean);
    } else {
      await checkPOSSaleFlow(tBean);
    }
  }

  async function checkPOSSaleFlow(terminalBean) {
    console.log("checkPOSSaleFlow");
    try {
      props.showProgress(translate("Looking for Active Sale Sessions"));
      let { data } = await API.get(
        "/api/v1/sale/activesession/" + terminalBean.terminalKey
      );
      setSaleSession(data);

      if (props.context.storeAdmin.enableShift) {
        let shift = SaleUtils.getShiftSaleSession(data);
        if (
          (shift.status === "active" || shift.status == "closing") &&
          shift.userId != props.userName
        ) {
          if (props.context.privileges.force_shift_close) {
            setCurrentScreen("blank");
            setConfirmOpen(true);
            setConfirmContext({
              title: translate("Shift Close"),
              message:
                translate("User ") +
                '"' +
                shift.userId +
                translate(
                  '" is having an active shift on this Terminal, Are you sure for force close the Shift'
                ),
              type: "warning",
              open: true,
              yes: true,
              no: true,
              context: "force_shift_close",
            });

            props.hideProgress();

            return;
          } else {
            props.setCurrentPage("blank");
            props.setAlert({
              show: true,
              title: translate("Alert!"),
              message:
                translate("User ") +
                '"' +
                shift.userId +
                translate(
                  '" is having an active shift on this Terminal, please close the shift before trying to Sale'
                ),
            });
            props.hideProgress();

            return;
          }
        }
      }

      if (data.status === "active") {
        setEnableSale(true);
        setDayOpenClose("day_close");
      } else if (data.status === "closing") {
        setEnableSale(false);
        setDayOpenClose("day_closing");
      } else {
        setEnableSale(false);
        setDayOpenClose("day_open");
      }
      props.hideProgress();
      setCurrentScreen("home");
    } catch (err) {
      console.log(err);
      setCurrentScreen("home");
      setEnableSale(false);
      setDayOpenClose("day_open");
      props.hideProgress();
    }
  }

  async function checkTradingSaleFlow(terminalBean) {
    try {
      try {
        props.showProgress(translate("Looking for Active Sale Sessions"));
        let { data } = await API.get(
          "/api/v1/sale/activesession/" + terminalBean.terminalKey
        );
        setSaleSession(data);
        props.hideProgress();
        setEnableSale(true);
        setCurrentScreen("home");
      } catch (err) {
        props.showProgress(translate("Creating Sale Session"));

        //Create if sale session not Exist
        await API.post(
          "/api/v1/sale/startSaleSession/" + terminalBean.terminalKey,
          {
            amount: 0,
          }
        );
        let { data } = await API.get(
          "/api/v1/sale/activesession/" + terminalBean.terminalKey
        );

        setSaleSession(data);
        props.hideProgress();
        setEnableSale(true);
        setCurrentScreen("home");
      }
    } catch (err) {
      setEnableSale(false);
      props.hideProgress();
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Not able to get active Sale session"),
      });
    }
  }
  let sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  function doNothing() {}

  const sideMenuList = [
    {
      key: "user",
      label: props.userName,
      icon: <PersonIcon />,
      action: doNothing,
      divider: false,
    },
  ];

  async function dayOpen() {
    if (props.context.storeAdmin.enableShift) {
      setShiftMode(true);
    }
    setShowDayOpen(true);
  }

  async function shiftClose() {
    try {
      setShiftMode(true);
      let { data } = await API.get(
        "/api/v1/sale/activesession/" + terminalBean.terminalKey
      );
      let shiftSession = SaleUtils.getShiftSaleSession(data);

      if (shiftSession.status === "active") {
        setShowDayCloseDataEntry(true);
      } else if (shiftSession.status === "closing") {
        setShowDayCloseSummary(true);
      }
    } catch (err) {
      props.showMessage(
        "error",
        translate("Not able to find Active Sale Session")
      );
    }
  }

  async function pdfViewer(data) {
    console.log("data", data);

    let fileList = [];

    let item = {
      selected: true,
      previewObj: data.data.data,
      fileType: "DOCUMENT",
      showAgent: true,
    };

    console.log(item);

    fileList.push(item);
    setPreviewFileList(fileList);
    setOpenFileViewWindow(true);
  }

  async function dayClose() {
    setShiftMode(false);
    if (props.context.storeAdmin.enableShift) {
      let shift = SaleUtils.getShiftSaleSession(saleSession);
      if (shift.status != "closed") {
        props.setAlert({
          show: true,
          title: translate("Message"),
          message: translate(
            'Please close active "Shift" from sale screen menu before trying "Day Close"'
          ),
        });
        return;
      }
    }

    try {
      let { data } = await API.get(
        "/api/v1/sale/activesession/" + terminalBean.terminalKey
      );
      if (data.status === "active") {
        if (props.context.storeAdmin.enableShift) {
          setConfirmOpen(true);
          setConfirmContext({
            title: translate("Day Close"),
            message: translate('Are you sure to perform "Day Close"'),
            type: "warning",
            open: true,
            yes: true,
            no: true,
            context: "day_close",
          });
        } else {
          setShowDayCloseDataEntry(true);
        }
      } else if (data.status === "closing") {
        setShowDayCloseSummary(true);
      }
    } catch (err) {
      props.showMessage(
        "error",
        translate("Not able to find Active Sale Session")
      );
    }
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes" && context.context == "day_close") {
      let { data } = await API.post("/api/v1/salesession/close_data_entry", {
        saleSessionId: saleSession.id,
        amount: 0,
        shiftMode: false,
      });
      setSaleSession(data);
      setShowDayCloseSummary(true);
    }
    if (value == "yes" && context.context == "force_shift_close") {
      setShiftMode(true);
      setShowDayCloseDataEntry(true);
    }
  }

  return (
    <div>
      {currenctScreen == "select_terminal" && (
        <TerminalSelector
          setCurrentPage={props.setCurrentPage}
          checkSaleFlow={checkSaleFlow}
          setTerminalBean={setTerminalBean}
          logOut={props.onLogOut}
          context={props.context}
        ></TerminalSelector>
      )}
      {currenctScreen == "propmpt_device_registration" && (
        <RegisterDevice
          setCurrentPage={props.setCurrentPage}
          checkSaleFlow={checkSaleFlow}
          setTerminalBean={setTerminalBean}
          deviceId={deviceId}
          onLogOut={props.onLogOut}
          context={props.context}
        ></RegisterDevice>
      )}
      {currenctScreen == "home" && (
        <Grid container>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {props.context.appType == "POS" ||
                props.context.appType == "M_POS"
                  ? "eSale POS - retail cloud"
                  : props.context.appType == "R_POS"
                  ? "eSale POS - Restaurant cloud"
                  : ""}
              </Typography>
            </Toolbar>
          </AppBar>
          {(props.context.appType == "POS" ||
            props.context.appType == "M_POS") &&
            terminalBean &&
            terminalBean.saleFeature && (
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        onClick={() => {
                          if (enableSale) {
                            onNewSale();
                          } else {
                            props.setAlert({
                              show: true,
                              title: translate("Message"),
                              message: translate(
                                'No Active Sale Session Found. Please start "Day Open"'
                              ),
                            });
                          }
                        }}
                      >
                        <AddCircleIcon
                          style={{
                            fontSize: "4rem",
                            color: enableSale ? green[500] : grey[500],
                          }}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {translate("Sale")}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}

          {props.context.appType == "R_POS" &&
            terminalBean &&
            terminalBean.saleFeature && (
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        onClick={() => {
                          if (enableSale) {
                            validateAndTriggerSale("r_sale");
                          } else {
                            props.setAlert({
                              show: true,
                              title: translate("Message"),
                              message: translate(
                                'No Active Sale Session Found. Please start "Day Open"'
                              ),
                            });
                          }
                        }}
                      >
                        <AppsIcon
                          style={{
                            fontSize: "4rem",
                            color: enableSale ? green[500] : grey[500],
                          }}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {translate("Console")}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}
          {(props.context.appType == "POS" ||
            props.context.appType == "M_POS") &&
            terminalBean &&
            terminalBean.saleReturnFeature && (
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          if (enableSale) {
                            onNewSaleReturn("SALE_RETURN");
                          } else {
                            props.setAlert({
                              show: true,
                              title: translate("Message"),
                              message: translate(
                                'No Active Sale Session Found. Please start "Day Open"'
                              ),
                            });
                          }
                        }}
                      >
                        <ReceiptIcon
                          style={{
                            fontSize: "4rem",
                            color: enableSale ? "#ad1457" : grey[500],
                          }}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {translate("Sale Return")}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}
          {(props.context.appType == "POS" ||
            props.context.appType == "M_POS") &&
            terminalBean &&
            terminalBean.saleOrderFeature && (
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          if (enableSale) {
                            onNewSaleOrder();
                          } else {
                            props.setAlert({
                              show: true,
                              title: translate("Message"),
                              message: translate(
                                'No Active Sale Session Found. Please start "Day Open"'
                              ),
                            });
                          }
                        }}
                      >
                        <PlaylistAddCheckIcon
                          style={{
                            fontSize: "4rem",
                            color: enableSale ? "#ff5719" : grey[500],
                          }}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {translate(
                        props.context.storeAdmin.saleOrderName
                          ? props.context.storeAdmin.saleOrderName
                          : "Sale Order"
                      )}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}

          {(props.context.appType == "POS" ||
            props.context.appType == "M_POS") &&
            terminalBean &&
            terminalBean.serviceReceiptFeature && (
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          if (enableSale) {
                            onNewService();
                          } else {
                            props.setAlert({
                              show: true,
                              title: translate("Message"),
                              message: translate(
                                'No Active Sale Session Found. Please start "Day Open"'
                              ),
                            });
                          }
                        }}
                      >
                        <BuildIcon
                          style={{
                            fontSize: "4rem",
                            color: enableSale ? cyan[700] : grey[500],
                          }}
                        />
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {translate("Service")}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}

          {!props.context.store.tradingMode && (
            <Grid item xs={4}>
              <Grid container>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          //syncDataFlag = false;
                          console.log("Click");
                          if (dayOpenClose === "day_open") dayOpen();
                          if (
                            dayOpenClose === "day_close" ||
                            dayOpenClose === "day_closing"
                          )
                            dayClose();
                        }}
                      >
                        {dayOpenClose == "day_open" && (
                          <EventIcon
                            style={{
                              fontSize: "4rem",
                              color: blue[500],
                            }}
                          />
                        )}
                        {(dayOpenClose === "day_close" ||
                          dayOpenClose === "day_closing") && (
                          <EventBusyIcon
                            style={{
                              fontSize: "4rem",
                              color: blue[500],
                            }}
                          />
                        )}
                      </IconButton>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    {dayOpenClose === "day_open" && (
                      <div style={{ textAlign: "center" }}>
                        {translate("Day Open")}
                      </div>
                    )}
                    {(dayOpenClose === "day_close" ||
                      dayOpenClose === "day_closing") && (
                      <div style={{ textAlign: "center" }}>
                        {translate("Day Close")}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={4}>
            <Grid container>
              <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      setCurrentScreen("sync");
                    }}
                  >
                    <Badge
                      color="secondary"
                      badgeContent={syncCount}
                      invisible={syncCount == 0}
                    >
                      <SyncIcon
                        style={{
                          fontSize: "4rem",
                          color: green[500],
                        }}
                      />
                    </Badge>
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>{translate("Sync")}</div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4}>
            <Grid container>
              <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      setCurrentScreen("setting");
                    }}
                  >
                    <SettingsIcon
                      style={{ fontSize: "4rem", color: brown[500] }}
                    />
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>
                  {translate("Settings")}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <div
            style={{
              height: AgentUtils.getWindowDimensions().height - 286 + "px",
            }}
          ></div>
        </Grid>
      )}
      {currenctScreen === "sale" && (
        <MSaleWindow
          title={translate("Sale")}
          setCurrentPage={setCurrentScreen}
          context={props.context}
          saleType={"SALE"}
          setAlert={props.setAlert}
          terminalBean={terminalBean}
          saleSession={saleSession}
          showMessage={props.showMessage}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          onLogOut={props.onLogOut}
          shiftClose={shiftClose}
          pdfViewer={pdfViewer}
          productCache={props.productCache}
          productCache2={props.productCache2}
        ></MSaleWindow>
      )}

      {currenctScreen === "r_sale" && (
        <MSaleWindow
          title={translate("Sale")}
          setCurrentPage={setCurrentScreen}
          context={props.context}
          saleType={"R_SALE"}
          setAlert={props.setAlert}
          terminalBean={terminalBean}
          saleSession={saleSession}
          showMessage={props.showMessage}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          onLogOut={props.onLogOut}
          shiftClose={shiftClose}
          pdfViewer={pdfViewer}
          productCache={props.productCache}
          productCache2={props.productCache2}
        ></MSaleWindow>
      )}

      {currenctScreen === "saleReturn" && (
        <MSaleWindow
          title={translate("Sale Return")}
          setCurrentPage={setCurrentScreen}
          setAlert={props.setAlert}
          showMessage={props.showMessage}
          context={props.context}
          saleType={"SALE_RETURN"}
          terminalBean={terminalBean}
          saleSession={saleSession}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          onLogOut={props.onLogOut}
          shiftClose={shiftClose}
          pdfViewer={pdfViewer}
          productCache={props.productCache}
          productCache2={props.productCache2}
        ></MSaleWindow>
      )}
      {currenctScreen === "saleOrder" && (
        <MSaleWindow
          title={translate(
            props.context.storeAdmin.saleOrderName
              ? props.context.storeAdmin.saleOrderName
              : "Sale Order"
          )}
          setCurrentPage={setCurrentScreen}
          setAlert={props.setAlert}
          context={props.context}
          saleType={"SALE_ORDER"}
          terminalBean={terminalBean}
          saleSession={saleSession}
          showMessage={props.showMessage}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          onLogOut={props.onLogOut}
          shiftClose={shiftClose}
          pdfViewer={pdfViewer}
          productCache={props.productCache}
          productCache2={props.productCache2}
        ></MSaleWindow>
      )}
      {currenctScreen === "service" && (
        <MSaleWindow
          title={translate("Service")}
          setCurrentPage={setCurrentScreen}
          setAlert={props.setAlert}
          context={props.context}
          saleType={"SERVICE"}
          terminalBean={terminalBean}
          saleSession={saleSession}
          showMessage={props.showMessage}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          onLogOut={props.onLogOut}
          shiftClose={shiftClose}
          pdfViewer={pdfViewer}
          productCache={props.productCache}
          productCache2={props.productCache2}
        ></MSaleWindow>
      )}
      {currenctScreen === "setting" && (
        <MSetting
          setCurrentScreen={setCurrentScreen}
          onLogOut={props.onLogOut}
          deviceId={deviceId}
          terminalBean={terminalBean}
          setTerminalBean={setTerminalBean}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setAlert={props.setAlert}
          context={props.context}
        ></MSetting>
      )}
      {currenctScreen === "sync" && (
        <MSync
          setCurrentScreen={setCurrentScreen}
          onLogOut={props.onLogOut}
        ></MSync>
      )}
      {showDayCloseDataEntry && (
        <DayCloseDataEntry
          biRef={biRef}
          context={props.context}
          showMessage={props.showMessage}
          saleSession={saleSession}
          setShowDayCloseDataEntry={setShowDayCloseDataEntry}
          setShowDayCloseSummary={setShowDayCloseSummary}
          checkSaleFlow={checkSaleFlow}
          terminalBean={terminalBean}
          shiftMode={shiftMode}
          pdfViewer={pdfViewer}
        ></DayCloseDataEntry>
      )}
      {showDayCloseSummary && (
        <DayCloseSummary
          biRef={biRef}
          context={props.context}
          showMessage={props.showMessage}
          setCurrentScreen={setCurrentScreen}
          checkSaleFlow={checkSaleFlow}
          saleSession={saleSession}
          setShowDayCloseSummary={setShowDayCloseSummary}
          setAlert={props.setAlert}
          terminalBean={terminalBean}
          shiftMode={shiftMode}
          pdfViewer={pdfViewer}
        ></DayCloseSummary>
      )}
      {showDayOpen && (
        <DayOpenDialog
          biRef={biRef}
          context={props.context}
          showMessage={props.showMessage}
          setCurrentScreen={setCurrentScreen}
          checkSaleFlow={checkSaleFlow}
          setShowDayOpen={setShowDayOpen}
          terminalBean={terminalBean}
          setAlert={props.setAlert}
          saleSession={saleSession}
          shiftMode={shiftMode}
          pdfViewer={pdfViewer}
        ></DayOpenDialog>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {localAlert.show && (
        <PAlert
          alert={localAlert}
          open={localAlert.show}
          setAlert={setLocalAlert}
        ></PAlert>
      )}
      {openFileViewWindow && (
        <PFileViewer
          openWindow={openFileViewWindow}
          setOpenWindow={setOpenFileViewWindow}
          showMessage={props.showMessage}
          filesList={previewFileList}
          setAlert={props.setAlert}
          disableDefaultPrint={true}
        ></PFileViewer>
      )}
    </div>
  );
}
